import React from "react";

const PosterGuideInfo = () => {
  return (
    <div className="lg:col-span-4">
      <h2 className="text-[10px] font-black uppercase tracking-[0.4em] text-slate-400 mb-2">
        General Information
      </h2>
      <h3 className="text-3xl font-black text-slate-900 dark:text-white mb-6 leading-tight">
        Call for Posters
      </h3>
      <div className="relative pl-6 border-l-4 border-blue-600 group transition-all duration-300 hover:border-blue-400">
        <p className="text-xl font-serif italic text-slate-800 dark:text-slate-300 leading-relaxed">
          "Visualisasikan riset Anda dengan struktur yang jelas, data yang akurat, dan desain yang komunikatif."
        </p>
      </div>
    </div>
  );
};

export default PosterGuideInfo;